var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.052,
    height: 41.572,
    viewBox: "0 0 39.052 41.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.386,19.939a1.89,1.89,0,0,0,3.779,0Zm3.779-14.8a1.89,1.89,0,0,0-3.779,0ZM17.5,11.845a1.89,1.89,0,1,0-1.566-3.439ZM6.64,25.7l-1.89-.01v.032ZM24.276,42.931l.022-1.89h-.043ZM41.912,25.7l1.89.022v-.032ZM32.617,8.406a1.89,1.89,0,1,0-1.566,3.439ZM26.165,19.939V5.14H22.386v14.8ZM15.934,8.406A19.1,19.1,0,0,0,4.75,25.688l3.779.02A15.321,15.321,0,0,1,17.5,11.845ZM4.75,25.72A19.327,19.327,0,0,0,24.3,44.821l-.043-3.779A15.547,15.547,0,0,1,8.529,25.676Zm19.5,19.1A19.327,19.327,0,0,0,43.8,25.72l-3.779-.044A15.547,15.547,0,0,1,24.3,41.042ZM43.8,25.688A19.1,19.1,0,0,0,32.617,8.406l-1.566,3.439a15.321,15.321,0,0,1,8.971,13.863Z",
    transform: "translate(-4.75 -3.25)",
    fill: "#f2f6f9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.baac056f4f6078dab3df61a4ef1817ab.svg";
export { ForwardRef as ReactComponent };